import { PlayTextStyles } from 'app/ui-components/typography/PlayText/PlayText.styles';
import styled from 'styled-components';
import { device } from '../../../ui-components/breakpoints';
import {
    iconArrowLeft,
    playGrey5,
    playTransitionEasing,
    regularWhite,
} from '../../../ui-components/design-tokens';
import { playFontIcon } from '../../../ui-components/typography/helpers';
import { PlayFocus } from '../../../ui-components/utils.styles';

export const StyledBackButtonText = styled.span`
    ${PlayTextStyles}
    text-shadow: 0 0 15px ${playGrey5};
    display: none;
    margin-left: 5px;
    vertical-align: middle;

    @media ${device.GteSmall} {
        display: inline;
    }
`;

export const StyledBackButton = styled.button`
    z-index: 300;
    pointer-events: all;
    display: block;
    color: ${regularWhite};
    position: absolute;
    top: 25px;
    left: 15px;
    cursor: pointer;
    text-decoration: none;
    line-height: 1;
    background: none;
    border: none;
    outline: none;
    ${PlayFocus}

    @media ${device.GteSmall} {
        left: 30px;
    }

    @media ${device.GteLarge} {
        left: 50px;
    }

    &:before {
        ${playFontIcon(2, iconArrowLeft)}
        text-shadow: 0 0 15px ${playGrey5};
        line-height: normal;
        text-decoration: none;
        transition: transform 200ms ${playTransitionEasing};
    }

    &:hover:before {
        transform: translateX(-4px);
    }

    &:hover {
        ${StyledBackButtonText} {
            text-decoration: underline solid ${regularWhite} 1px;
            text-underline-position: under;
        }
    }
`;
